const ExtensionReportMenus = [ 
    {
      icon: "summarize",
      key: "billingcdrsummary",
      name: "Extension Performance Summary",
      url: "home/app/extensionPerformanceSummary",
      description:"",
      productionReady: true,
      disabled: false,
    },
    {
      icon: "details",
      key: "billingcdrdetails",
      name: "Extension CDR Details",
      url: "home/app/billingcdrdetails",
      description: "",
      productionReady: true,
      disabled: false,
    },
  ];
  
  export { ExtensionReportMenus };
  